<template>
  <ol class="list-decimal">
    <li>
      <RevLink
        :to="{
          name: ROUTE_NAMES.OPTIONS.BATCH_LISTING_CREATION,
        }"
      >
        {{ i18n(translations.generateCsv) }}
      </RevLink>
    </li>
    <li>
      {{ i18n(translations.fillOutListingDetails) }}
    </li>
    <li>
      {{ i18n(translations.uploadFinalCsv) }}
    </li>
  </ol>

  <div v-if="shouldShowAdditionalInfo" class="mt-4">
    <span>{{ i18n(translations.stateColumnHint) }}</span>
    <ul>
      <li>
        {{ i18n(translations.mintState) }}
      </li>
      <li>
        {{ i18n(translations.veryGoodState) }}
      </li>
      <li>
        {{ i18n(translations.goodState) }}
      </li>
      <li>
        {{ i18n(translations.fairState) }}
      </li>
      <li>
        {{ i18n(translations.stalloneState) }}
      </li>
      <li v-if="isPremiumGradeListingsEnabled">
        {{ i18n(translations.premiumState) }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from '../Form.translations'

const i18n = useI18n()

defineProps<{
  type: string
  isPremiumGradeListingsEnabled: boolean
  shouldShowAdditionalInfo: boolean
}>()
</script>
